function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup04Ico04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123.91 114.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.19,19.51v-2.59c0-3.73-3.03-6.76-6.76-6.76s-6.76,3.02-6.76,6.76v38.28M37.18,79.69c-3.42-3.36-7.9-5.65-12.9-6.29-1.76-.22-3.24-1.43-3.77-3.13l-3.98-12.9c-1.29-4.81-6.23-7.66-11.03-6.37l-4.35,1.17,8.22,31.54c.52,1.99,1.48,3.83,2.82,5.38l10.4,12.13c.7.82,1.08,1.86,1.08,2.93v.59M95.74,111.5c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25ZM37.18,104.74h-17.02v9.01M50.69,113.75v-13.51h54.05v13.51M19.17,46.19v-20.27c0-3.73,3.02-6.76,6.76-6.76s6.76,3.02,6.76,6.76M79.97,86.73c0-11.9,9.23-21.65,20.93-22.47.95-.07,1.78-.67,2.06-1.58l4.42-14.32c1.29-4.81,6.23-7.66,11.03-6.37l4.35,1.17-8.22,31.54c-.52,1.99-1.48,3.83-2.82,5.39l-9.86,11.5c-1.05,1.22-1.63,2.78-1.63,4.4v4.26M64.21,30.43c0-3.85-3.22-6.95-7.12-6.75-3.65.19-6.39,3.47-6.39,7.13v48.35c0,3.5.81,6.94,2.38,10.07l1.18,2.35c.63,1.25.95,2.63.95,4.03v4.63M104.75,37.18v-20.27c0-3.73-3.02-6.76-6.76-6.76s-6.76,3.02-6.76,6.76M77.72,48.44V7.9c0-3.73,3.02-6.76,6.76-6.76s6.76,3.02,6.76,6.76v40.54M64.21,52.95V16.91c0-3.73,3.02-6.76,6.76-6.76s6.76,3.02,6.76,6.76",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup04Ico04);
export default __webpack_public_path__ + "static/media/sezione-05-popup-04-ico-04.0794cdd1865ee1221cf6816f185e703e.svg";
export { ForwardRef as ReactComponent };